import { TurnType } from "../../algorithms/algorithm";
import { parsePyraminxAlgorithm } from "../../algorithms/pyraminx";
import { fillArray } from "../../utils/arrays";
import { Simulator } from "./../simulator";
export class PyraminxSimulator extends Simulator {
    constructor() {
        super();
        const { stickerIds: U } = this.addFace(fillArray(9, "top"), "top");
        const { stickerIds: L } = this.addFace(fillArray(9, "left"), "left");
        const { stickerIds: R } = this.addFace(fillArray(9, "right"), "right");
        const { stickerIds: B } = this.addFace(fillArray(9, "back"), "back");
        // Tip turns
        this.addTurn([
            [U[8], R[8]],
            [R[8], L[8]],
            [L[8], U[8]],
        ], "u");
        this.addTurn([
            [L[0], B[8]],
            [B[8], U[4]],
            [U[4], L[0]],
        ], "l");
        this.addTurn([
            [L[4], R[0]],
            [R[0], B[4]],
            [B[4], L[4]],
        ], "r");
        this.addTurn([
            [R[4], U[0]],
            [U[0], B[0]],
            [B[0], R[4]],
        ], "b");
        // Full turns
        this.addTurn([
            [U[5], R[5]],
            [U[6], R[6]],
            [U[7], R[7]],
            [U[8], R[8]],
            [R[5], L[5]],
            [R[6], L[6]],
            [R[7], L[7]],
            [R[8], L[8]],
            [L[5], U[5]],
            [L[6], U[6]],
            [L[7], U[7]],
            [L[8], U[8]],
        ], "U");
        this.addTurn([
            [L[0], B[8]],
            [L[1], B[6]],
            [L[2], B[5]],
            [L[5], B[7]],
            [B[8], U[4]],
            [B[6], U[3]],
            [B[5], U[7]],
            [B[7], U[2]],
            [U[4], L[0]],
            [U[3], L[1]],
            [U[7], L[2]],
            [U[2], L[5]],
        ], "L");
        this.addTurn([
            [L[2], R[5]],
            [L[3], R[1]],
            [L[4], R[0]],
            [L[7], R[2]],
            [R[5], B[2]],
            [R[1], B[3]],
            [R[0], B[4]],
            [R[2], B[7]],
            [B[2], L[2]],
            [B[3], L[3]],
            [B[4], L[4]],
            [B[7], L[7]],
        ], "R");
        this.addTurn([
            [R[2], U[5]],
            [R[3], U[1]],
            [R[4], U[0]],
            [R[7], U[2]],
            [U[5], B[5]],
            [U[1], B[1]],
            [U[0], B[0]],
            [U[2], B[2]],
            [B[5], R[2]],
            [B[1], R[3]],
            [B[0], R[4]],
            [B[2], R[7]],
        ], "B");
    }
    U(reverse) {
        this.doTurn("U", reverse);
    }
    R(reverse) {
        this.doTurn("R", reverse);
    }
    L(reverse) {
        this.doTurn("L", reverse);
    }
    B(reverse) {
        this.doTurn("B", reverse);
    }
    u(reverse) {
        this.doTurn("u", reverse);
    }
    r(reverse) {
        this.doTurn("r", reverse);
    }
    l(reverse) {
        this.doTurn("l", reverse);
    }
    b(reverse) {
        this.doTurn("b", reverse);
    }
    alg(alg) {
        if (!alg) {
            return;
        }
        this.doTurns(parsePyraminxAlgorithm(alg));
    }
    case(alg) {
        if (!alg) {
            return;
        }
        let turns = parsePyraminxAlgorithm(alg)
            .reverse()
            .map((turn) => (Object.assign(Object.assign({}, turn), { turnType: turn.turnType === TurnType.Clockwise
                ? TurnType.CounterClockwise
                : TurnType.Clockwise })));
        this.doTurns(turns);
    }
    doTurns(turns) {
        turns.forEach((turn) => {
            let reverse = turn.turnType === TurnType.CounterClockwise;
            switch (turn.unit) {
                case "R":
                    this.R(reverse);
                    break;
                case "r":
                    this.r(reverse);
                    break;
                case "U":
                    this.U(reverse);
                    break;
                case "u":
                    this.u(reverse);
                    break;
                case "L":
                    this.L(reverse);
                    break;
                case "l":
                    this.l(reverse);
                    break;
                case "B":
                    this.B(reverse);
                    break;
                case "b":
                    this.b(reverse);
                    break;
            }
        });
    }
}
